import React from 'react';

import { Menu, MenuItem, ListItemText } from '@mui/material';


const ContextMenu = ({ contextMenu, handleClose, handleOpenModal }) => (
  <Menu
    open={contextMenu !== null}
    onClose={handleClose}
    anchorReference="anchorPosition"
    anchorPosition={
      contextMenu !== null
        ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
        : undefined
    }
    componentsProps={{
      root: {
        onContextMenu: e => {
          e.preventDefault();
          handleClose();
        }
      }
    }}
  >
    {/* <MenuItem onClick={() => handleOpenModal('issueReceipt')}>
      <ListItemText primary="Wystaw paragon" />
    </MenuItem> */}
    <MenuItem onClick={() => handleOpenModal('sendMessage')}>
      <ListItemText primary="Wyślij wiadomość" />
    </MenuItem>
    <MenuItem onClick={() => handleOpenModal('duplicateOrder')}>
      <ListItemText primary="Duplikuj" />
    </MenuItem>
    <MenuItem onClick={() => handleOpenModal('deleteOrder')}>
      <ListItemText primary="Usuń" />
    </MenuItem>
    <MenuItem onClick={() => handleOpenModal('changeState')}>
      <ListItemText primary="Zmień status" />
    </MenuItem>
  </Menu>
);

export default ContextMenu;
